import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=4ae691cb&scoped=true&"
import script from "./ChatBot.vue?vue&type=script&lang=js&"
export * from "./ChatBot.vue?vue&type=script&lang=js&"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=4ae691cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae691cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae691cb')) {
      api.createRecord('4ae691cb', component.options)
    } else {
      api.reload('4ae691cb', component.options)
    }
    module.hot.accept("./ChatBot.vue?vue&type=template&id=4ae691cb&scoped=true&", function () {
      api.rerender('4ae691cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/ChatBot/ChatBot.vue"
export default component.exports